import type { Plugin } from '~/models/Plugin'
import { VueQueryPlugin } from '@tanstack/vue-query'

export const install: Plugin['fn'] = (app) => {
  app.use(VueQueryPlugin)
}
